import React, { createContext, useState } from 'react';

export const TagFilterContext = createContext();

export function TagFilterProvider({ children }) {
    const [globalTagFilter, setGlobalTagFilter] = useState("");

    return (
        <TagFilterContext.Provider value={{ globalTagFilter, setGlobalTagFilter }}>
            {children}
        </TagFilterContext.Provider>
    );
}

export function useTagFilter() {
    const context = React.useContext(TagFilterContext);
    if (!context) {
        throw new Error('useTagFilter must be used within TagFilterProvider');
    }
    return context;
}